import React, { RefObject } from 'react';
import { TextArrowLink } from '../../../components';
import { useScrollReveal } from '../../../hooks';
import { SectionHeader } from '../../../sections/ThesisSection/layouts';
import { FACTS, LINKS } from '../content';
import { RequestTile, ResponseTile } from '../figures/CodeBox';
import { rich } from '../rich';
import { Band, reveal } from './Band';

// The request and its answer as tiles, and three facts as an open list beside them. From a
// tablet up the request holds the left and the answer sits over the facts on the right; on a
// small tablet or a phone the three stack.
export function BuildSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });
  return (
    <Band id="developers">
      <div ref={ref as RefObject<HTMLDivElement>}>
        <SectionHeader
          label="For developers"
          title="One request from your code."
          description={rich('Send the context and your questions to `/v1/decide`, or use the Python and TypeScript clients.')}
          isVisible={isVisible}
          labelColor="ink"
        />

        <div className={`oh-section-link ${reveal(isVisible)}`} style={{ animationDelay: '0.2s' }}>
          <TextArrowLink href={LINKS.docs} target="_blank" rel="noopener noreferrer">Read the docs</TextArrowLink>
        </div>

        <div className="oh-dev">
          <RequestTile className={reveal(isVisible)} style={{ animationDelay: '0.25s' }} />
          <div className="oh-dev-side">
            <ResponseTile className={reveal(isVisible)} style={{ animationDelay: '0.33s' }} />
            <ul className={`oh-dev-facts ${reveal(isVisible)}`} style={{ animationDelay: '0.41s' }}>
              {FACTS.map((fact) => (
                <li key={fact.title}>
                  <h3 className="font-display text-subheading-sm text-foreground">{fact.title}</h3>
                  <p className="mt-1 font-body text-body-sm text-foreground-tertiary">{rich(fact.text)}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Band>
  );
}

export default BuildSection;
